import Damage from "../../../../model/crew/Damage";
import BigNum from "../../../../model/math/BigNum";
import NumberFormatter from "../../../../util/NumberFormatter";
import Page from "../../../framework/Page";
import View from "../../../framework/View";

export default class RubyDamageView extends View {
    /**
     * @param {string} parentId
     * @param {Damage} damage
     */
    constructor(parentId, damage) {
        super(parentId, parentId + '_ruby');

        /**
         * @constant
         * @type {Damage}
         */
        this.damage = damage;

        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedDamageMultiplier = new BigNum(-1);
        /**
         * @type {string}
         */
        this.damageBonusString = null;

        /**
         * @type {HTMLElement}
         */
        this.body = null;

        this.setInitialVisibility(true);
    }

    /**
     * @override
     */
    initializeView() {
  
        const parentElement = Page.getElement(this.parentId);

        ////////////////////////////////////
        // gold
        ////////////////////////////////////

        const container = Page.createElement('div', parentElement, this.getElementId(), 'mine-damage-panel-main-section');
        
        const header = Page.createElement('div', container, null, 'mine-damage-panel-section-header');
        header.innerHTML = 'Ruby';

        this.body = Page.createElement('div', container, null, 'mine-damage-panel-section-body');

        super.initializeView();        
    }

    /**
     * @override
     */
    updateViewContents() {

        const damageMultiplier = this.damage.rubyDamageMultiplier;

        if (!this.damageBonusString || !damageMultiplier.equals(this.displayedDamageMultiplier)) {
            this.displayedDamageMultiplier.copy(damageMultiplier);
            this.damageBonusString = NumberFormatter.formatBigNum(damageMultiplier);
            this.body.innerHTML = this.damageBonusString;
        }

        super.updateViewContents();
    }

    /**
     * @override
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'inline-block'; // This is a span element.  Don't use display:block.
    }

}